import apply from '../methods/apply'

function updateClassList(name, element, classes) {
  if (!element.classList)
    return

  const exists  = item => element.classList.contains(item)
  const valName = `_${name}VesselClasses`
  const prevVal = (element[valName] || []).filter(exists)
  const nextVal = classes.filter(name => name && name.length)

  if (prevVal.length) {
    let classes = prevVal.filter(name => !nextVal.includes(name))
    element.classList.remove(...classes)
  }

  if (nextVal.length) {
    let classes = nextVal.filter(name => !prevVal.includes(name))
    element.classList.add(...classes)

    element[valName] = nextVal
  }
}

export default function directive(name, element, options) {
  const classes = apply(options)
  updateClassList(name, element, Object.keys(classes))
}
